/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_ATTRIBUTE, DELETE_ATTRIBUTE } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { CREATE_ATTRIBUTE } from "../graphql/createAttribute.mutation";

const log: any = LoggerModule?.getInstance();

export interface UpdateAttributeProps {
  formData: {
    name?: string;
    year?: string;
    status?: string;
  };
  id: string;
}
export interface CreateAttributeProps {
  formData: {
    alias?: string;
    description?: string;
    img1?: string;
    img2?: string;
    isVisible?: boolean;
    minDownPayment?: string;
    regMode?: string;
  };
  id: string;
}
export interface DeleteAttributeProps {
  id: string;
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IAttributeMethods extends IPluginMethodMap {
  updateAttribute(args: any): Promise<any>;
  createAttribute(args: any): Promise<any>;
  deleteAttribute(args: any): Promise<any>;
}

export class AttributeService implements IAgentPlugin {
  readonly methods: IAttributeMethods;

  constructor() {
    this.methods = {
      updateAttribute: this.updateAttribute.bind(this),
      createAttribute: this.createAttribute.bind(this),
      deleteAttribute: this.deleteAttribute.bind(this),
    };
  }

  async createAttribute(args: CreateAttributeProps) {
    log.blue(`inviteUser server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        log.blue(`inviteUser server component222:`, args);
        const res = await client.mutate({
          mutation: CREATE_ATTRIBUTE,
          variables: {
            data: {
              ...args,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.createCostumeAttribute,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  async updateAttribute(args: UpdateAttributeProps) {
    log.blue(`inviteUser server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        log.blue(`inviteUser server component222:`, args);
        const res = await client.mutate({
          mutation: UPDATE_ATTRIBUTE,
          variables: {
            filter: {
              _id: args?.id,
            },
            update: {
              ...args?.formData,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.updateCostumeAttribute,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  async deleteAttribute(args: DeleteAttributeProps) {
    log.blue(`inviteUser server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: DELETE_ATTRIBUTE,
          variables: {
            filter: {
              _id: args?.id,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
